export const UPDATE_ELECTION_QUERY_KEY = ['update', 'election'] as const;

export const benefitFactiodMapper = new Map<string, string>([
  ['allstate_grp_medical', 'hospitalIndemnity'],
  ['colonial_group_hospital_confinement_indemnity_0', 'hospitalIndemnity'],
  ['colonial_group_hospital_confinement_indemnity_1', 'hospitalIndemnity'],
  ['colonial_group_hospital_confinement_indemnity_2', 'hospitalIndemnity'],
  [
    'colonial_group_hospital_confinement_indemnity_disabled',
    'hospitalIndemnity',
  ],
  ['critical_illness', 'criticalIllness'],
  ['critical_illness_2', 'criticalIllness'],
  ['critical_illness_3', 'criticalIllness'],
  ['critical_assistance_advance_coverage', 'criticalIllness'],
  ['colonial_group_hospital_confinement_indemnity_spouse', 'hospitalIndemnity'],
  ['group_hospital_indemnity', 'hospitalIndemnity'],
  ['unum_group_hospital_indemnity_employee', 'hospitalIndemnity'],
  ['partner_market_place_pet_insurance', 'petInsurance'],
  ['std', 'std'],
  ['ltd', 'ltd'],
  ['bltd', 'ltd'],
  ['bstd', 'std'],
  ['partner_market_place_legal', 'legal'],
  ['legal', 'legal'],
  ['partner_market_place_eap', 'eap'],
  ['eap', 'eap'],
  ['partner_market_place_home_auto', 'homeAuto'],
  ['partner_market_place_identity', 'identity'],
  ['id_theft', 'identity'],
  ['accident_advance_coverage', 'accident'],
  ['aflac_accidental', 'accident'],
  ['allstate_grp_accident', 'accident'],
  ['basic_add', 'accident'],
  ['Rider_AD&D', 'accident'],
  ['add', 'accident'],
  ['colonial_accident_0', 'accident'],
  ['colonial_accident_1', 'accident'],
  ['colonial_accident_2', 'accident'],
  ['colonial_accident_child', 'accident'],
  ['colonial_accident_child_1', 'accident'],
  ['colonial_accident_child_2', 'accident'],
  ['colonial_accident_child_3', 'accident'],
  ['colonial_accident_spouse', 'accident'],
  ['colonial_group_accident_0', 'accident'],
  ['colonial_group_accident_1', 'accident'],
  ['colonial_group_accident_disabled', 'accident'],
  ['unum_group_accident_employee', 'accident'],
  ['allstate_accident', 'accident'],
  ['allstate_accident2', 'accident'],
  ['basic_subscriber_life', 'basic_subscriber_life'],
]);

export const VALID_401K_BENEFIT_LOOKUP_CODES = [
  '401k',
  '401k_catch_up',
  '401k_roth',
  '401k_roth_catch_up',
];
